import { defineMessages } from '@/i18n'

export const messages = defineMessages({
  ru: {
    // Гайд подключения
    guideTitle: 'Подключите OA Studio к вашему ИИ-агенту',
    guideLead:
      'Собирайте курсы промптом: агент раскладывает материал по урокам и блокам и создаёт для них иллюстрации, видео и озвучку через инструменты OA Studio.',
    guideAbout: 'Что это даёт',
    howToConnect: 'Как подключить',
    connectClaude: 'Подключить к Claude',
    claudeGuide: 'Пошаговый гайд',
    claudeCodeSend: 'Скопируйте и отправьте это в Claude Code',
    claudeDialogTitle: 'Подключите OA Studio к Claude за минуту',
    claudeStep1Title: 'Войдите в Claude в браузере',
    claudeStep1Lead: 'Откройте',
    claudeStep1Tail: 'и войдите в свой аккаунт.',
    claudeStep2Title: 'Установите и войдите в',
    claudeStep2Lead:
      'Откройте Customize → Connectors. Добавьте новый коннектор, назовите его OA Studio и вставьте адрес:',
    claudeStep2Tail: '— или нажмите кнопку ниже.',
    claudeStep2Button: 'Добавить OA Studio MCP',
    claudeStep3Title: 'Создавайте курсы с OA Studio в Claude',
    claudeStep3Text:
      'Откройте новый чат и опишите курс, который хотите собрать. Claude разложит материал по урокам и блокам через инструменты OA Studio.',
    claudeStep3Button: 'Начать создавать',
    whatToWrite: 'Что написать в чате',
    faq: 'Частые вопросы',
    // Подключённые
    connectors: 'Коннекторы',
    connectedTab: 'Подключённые',
    loadFailed: 'Ой, подключения не загрузились…',
    loadFailedHint: 'Попробуйте обновить страницу.',
    noConnections: 'Ой, а вы ещё не подключили ни одного коннектора…',
    revoke: 'Отозвать',
    revokeTitle: (name: string) => `Отозвать доступ для «${name}»?`,
    revokeDescription:
      'Клиент потеряет доступ к вашим курсам. Это действие можно отменить, подключившись заново.',
    cancel: 'Отмена',
    revokeConfirm: 'Отозвать доступ',
    // Согласие OAuth
    requestsAccess: (name: string) => `${name} запрашивает доступ`,
    toAuthorAccount: 'к вашему авторскому аккаунту',
    consentLead: 'Приложение сможет управлять вашим контентом через API:',
    accessEdit: 'Создавать и редактировать ваши курсы',
    accessPublish: 'Публиковать и удалять созданные курсы',
    consentRevokeNote: 'Вы можете отозвать доступ в любой момент в разделе «Коннекторы».',
    deny: 'Отклонить',
    allow: 'Разрешить',
    requestExpired: 'Запрос устарел',
    requestExpiredHint: 'Начните подключение заново в Claude.',
    authorRequired: 'Нужен аккаунт автора',
    requestLoadFailed: 'Не удалось загрузить запрос',
    tryAgain: 'Попробуйте ещё раз.',
    badLink: 'Некорректная ссылка',
    loginRequired: 'Требуется вход…',
    loading: 'Загрузка…',
    actionFailed: 'Не удалось выполнить действие. Попробуйте ещё раз.',
  },
  en: {
    guideTitle: 'Connect OA Studio to your AI agent',
    guideLead:
      'Build courses with a prompt: the agent lays out the material into lessons and blocks and creates illustrations, video and voiceover for them using OA Studio tools.',
    guideAbout: 'What it does',
    howToConnect: 'How to connect',
    connectClaude: 'Connect to Claude',
    claudeGuide: 'Step-by-step guide',
    claudeCodeSend: 'Copy and send this to Claude Code',
    claudeDialogTitle: 'Connect OA Studio to Claude in under a minute',
    claudeStep1Title: 'Sign in to Claude in your browser',
    claudeStep1Lead: 'Go to',
    claudeStep1Tail: 'and sign in to your account.',
    claudeStep2Title: 'Add and sign in to',
    claudeStep2Lead:
      'Go to Customize → Connectors. Add a new connector, name it OA Studio, and paste this URL:',
    claudeStep2Tail: '— or click the button below.',
    claudeStep2Button: 'Add OA Studio MCP',
    claudeStep3Title: 'Create courses with OA Studio in Claude',
    claudeStep3Text:
      'Start a new chat and describe the course you want to build. Claude will lay out the material into lessons and blocks using OA Studio tools.',
    claudeStep3Button: 'Start creating',
    whatToWrite: 'What to write in the chat',
    faq: 'FAQ',
    connectors: 'Connectors',
    connectedTab: 'Connected',
    loadFailed: 'Oops, your connections didn’t load…',
    loadFailedHint: 'Try refreshing the page.',
    noConnections: 'Oops, you haven’t added any connectors yet…',
    revoke: 'Revoke',
    revokeTitle: (name: string) => `Revoke access for “${name}”?`,
    revokeDescription: 'The app will lose access to your courses. To restore it, connect again.',
    cancel: 'Cancel',
    revokeConfirm: 'Revoke access',
    requestsAccess: (name: string) => `${name} is requesting access`,
    toAuthorAccount: 'to your author account',
    consentLead: 'The app will be able to manage your content via the API:',
    accessEdit: 'Create and edit your courses',
    accessPublish: 'Publish and delete the courses it creates',
    consentRevokeNote: 'You can revoke access at any time in Connectors.',
    deny: 'Deny',
    allow: 'Allow',
    requestExpired: 'Request expired',
    requestExpiredHint: 'Start the connection again in Claude.',
    authorRequired: 'An author account is required',
    requestLoadFailed: 'Couldn’t load the request',
    tryAgain: 'Try again.',
    badLink: 'Invalid link',
    loginRequired: 'Sign-in required…',
    loading: 'Loading…',
    actionFailed: 'Something went wrong. Try again.',
  },
})
